// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3297u","label":"CategoryService_label__1JJi4","location":"CategoryService_location__1aeqt"};